function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Menu, Button, Drawer, Avatar, Image, Space, Input } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import AccountNav from "../AccountNav";
import UserConnectDrawer from "../UserConnectDrawer";
import { HouseFill, MegaphoneFill, DoorOpenFill, PersonLinesFill, PersonFill, Grid3x3GapFill } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var DefaultNav = function DefaultNav(_ref) {
  var _ref$handleConnectDra = _ref.handleConnectDrawer,
    handleConnectDrawer = _ref$handleConnectDra === void 0 ? false : _ref$handleConnectDra,
    _ref$hideDrawer = _ref.hideDrawer,
    hideDrawer = _ref$hideDrawer === void 0 ? function () {} : _ref$hideDrawer,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? 'home' : _ref$selected;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerVisible = _useState2[0],
    setDrawerVisible = _useState2[1];
  var showDrawer = function showDrawer() {
    setDrawerVisible(true);
  };
  var onDrawerClose = function onDrawerClose() {
    setDrawerVisible(false);
  };
  var _useState3 = useState(Common.currentUser != null),
    _useState4 = _slicedToArray(_useState3, 2),
    userIsConnected = _useState4[0],
    setUserIsConnected = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    connectDrawerVisible = _useState6[0],
    setConnectDrawerVisible = _useState6[1];
  var showConnectDrawer = function showConnectDrawer() {
    setConnectDrawerVisible(true);
  };
  var onConnectDrawerClose = function onConnectDrawerClose() {
    setConnectDrawerVisible(false);
    hideDrawer();
  };
  var navigate = useNavigate();
  var _useState7 = useState(selected),
    _useState8 = _slicedToArray(_useState7, 2),
    current = _useState8[0],
    setCurrent = _useState8[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
  };
  var user = Common.currentUser;
  var search = function search(value) {
    if (value != 'undefined' && value.length) {
      navigate('/search/' + value.toString());
    }
  };
  useEffect(function () {
    setConnectDrawerVisible(handleConnectDrawer);
  }, [handleConnectDrawer]);
  useEffect(function () {
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).id : null
    }).then(function (response) {
      if (response.data.auth == true) {
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        setUserIsConnected(true);
      } else {
        localStorage.removeItem('userData');
        localStorage.removeItem('isOn');
        setUserIsConnected(false);
      }
    });
  });
  useEffect(function () {});
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "nav-wrapper",
      children: userIsConnected ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Drawer, {
          title: "Mon compte",
          width: 330,
          closable: true,
          onClose: onDrawerClose,
          visible: drawerVisible,
          children: /*#__PURE__*/_jsx(AccountNav, {})
        }), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: {
                span: 11
              },
              md: {
                span: 10
              },
              sm: 9,
              xs: 8,
              children: /*#__PURE__*/_jsxs("nav", {
                className: "navbar navbar-icon-top navbar-expand-lg navbar-light bg-light",
                style: {
                  background: "#FFFFFF"
                },
                children: [/*#__PURE__*/_jsx("a", {
                  className: "navbar-brand",
                  href: "#",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "nav-logo",
                    children: /*#__PURE__*/_jsx("img", {
                      src: "drawables/nl1_rm.png",
                      style: {
                        width: '100%',
                        marginTop: '0px'
                      }
                    })
                  })
                }), /*#__PURE__*/_jsx("button", {
                  className: "navbar-toggler",
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#navbarSupportedContent",
                  "aria-controls": "navbarSupportedContent",
                  "aria-expanded": "false",
                  "aria-label": "Toggle navigation",
                  children: /*#__PURE__*/_jsx("span", {
                    className: "navbar-toggler-icon"
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "collapse navbar-collapse",
                  id: "navbarSupportedContent",
                  children: [/*#__PURE__*/_jsx("ul", {
                    className: "nabar-nav"
                  }), /*#__PURE__*/_jsxs("ul", {
                    className: "navbar-nav mr-auto",
                    children: [/*#__PURE__*/_jsx("li", {
                      className: "nav-item active",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(HouseFill, {
                            size: 20
                          })
                        }), "Accueijl", /*#__PURE__*/_jsx("span", {
                          className: "sr-only",
                          children: "(current)"
                        })]
                      })
                    }), /*#__PURE__*/_jsx("li", {
                      className: "nav-item",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/ads",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(MegaphoneFill, {
                            size: 20
                          })
                        }), "Avis"]
                      })
                    }), /*#__PURE__*/_jsx("li", {
                      className: "nav-item",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/entreprises",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(DoorOpenFill, {
                            size: 20
                          })
                        }), "Organisations"]
                      })
                    }), /*#__PURE__*/_jsx("li", {
                      className: "nav-item",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/compte",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(DoorOpenFill, {
                            size: 20
                          })
                        }), "Mon compte"]
                      })
                    })]
                  }), /*#__PURE__*/_jsx("div", {
                    className: "form-inline",
                    children: /*#__PURE__*/_jsx(Search, {
                      size: "middle",
                      allowClear: true,
                      placeholder: "Que cherchez-vous ?",
                      onSearch: search
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 1,
              md: 2,
              sm: 3,
              xs: 4,
              className: "all-center",
              children: /*#__PURE__*/_jsxs(Space, {
                orientation: "horizontal",
                children: [/*#__PURE__*/_jsx(Avatar, {
                  src: /*#__PURE__*/_jsx(Image, {
                    src: user.avatar,
                    style: {
                      width: '70px'
                    }
                  }),
                  shape: "square",
                  size: "middle",
                  icon: /*#__PURE__*/_jsx(PersonFill, {})
                }), /*#__PURE__*/_jsx("a", {
                  className: "right-link",
                  onClick: showDrawer,
                  children: /*#__PURE__*/_jsx(Grid3x3GapFill, {
                    size: 24
                  })
                })]
              })
            })]
          })
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 7,
              md: 10,
              sm: 8,
              xs: 8,
              children: /*#__PURE__*/_jsxs("nav", {
                className: "navbar navbar-icon-top navbar-expand-lg navbar-light bg-light",
                style: {
                  background: "#FFFFFF"
                },
                children: [/*#__PURE__*/_jsx("a", {
                  className: "navbar-brand",
                  href: "#",
                  children: /*#__PURE__*/_jsx("div", {
                    className: "nav-logo",
                    children: /*#__PURE__*/_jsx("img", {
                      src: "drawables/ht.png",
                      style: {
                        width: '100%',
                        marginTop: '0px'
                      }
                    })
                  })
                }), /*#__PURE__*/_jsx("button", {
                  className: "navbar-toggler",
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#navbarSupportedContent",
                  "aria-controls": "navbarSupportedContent",
                  "aria-expanded": "false",
                  "aria-label": "Toggle navigation",
                  children: /*#__PURE__*/_jsx("span", {
                    className: "navbar-toggler-icon"
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "collapse navbar-collapse",
                  id: "navbarSupportedContent",
                  children: [/*#__PURE__*/_jsx("ul", {
                    className: "nabar-nav"
                  }), /*#__PURE__*/_jsxs("ul", {
                    className: "navbar-nav mr-auto",
                    children: [/*#__PURE__*/_jsx("li", {
                      className: "nav-item active",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(HouseFill, {
                            size: 20
                          })
                        }), "Accueil", /*#__PURE__*/_jsx("span", {
                          className: "sr-only",
                          children: "(current)"
                        })]
                      })
                    }), /*#__PURE__*/_jsx("li", {
                      className: "nav-item",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/ads",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(MegaphoneFill, {
                            size: 20
                          })
                        }), "Avis"]
                      })
                    }), /*#__PURE__*/_jsx("li", {
                      className: "nav-item",
                      children: /*#__PURE__*/_jsxs("a", {
                        className: "nav-link",
                        href: "/#/entreprises",
                        children: [/*#__PURE__*/_jsx("i", {
                          className: "fa",
                          children: /*#__PURE__*/_jsx(DoorOpenFill, {
                            size: 20
                          })
                        }), "Organisations"]
                      })
                    })]
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 3,
              className: "d-lg-block d-md-none d-sm-none d-none",
              children: /*#__PURE__*/_jsx("div", {
                className: "all-center",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "default",
                  href: "/#/companiestips",
                  style: {
                    background: '#63D5DF',
                    color: '#010101',
                    border: 'none'
                  },
                  children: "Vous etes une Entreprise ?"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: 2,
              md: 2,
              sm: 4,
              xs: 4,
              children: /*#__PURE__*/_jsx("div", {
                className: "all-center",
                children: /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: showConnectDrawer,
                  children: "Connexion"
                })
              })
            })]
          })
        })
      })
    })
  });
};
export default DefaultNav;